/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'people.menu.renotify.flag.description':
    'We sturen iedereen een e-mail met een herinnering. Dit kan wel een minuut duren.',
  'people.menu.renotify.flag.title': 'Herinneringen sturen',
  'people.menu.renotify.menu.description':
    '{userCount, plural, one {{userCount,number} persoon heeft de uitnodiging voor {product} nog niet geaccepteerd. Bekijk wie er ontbreekt en stuur diegene een herinnering.} other {{userCount,number} personen hebben hun uitnodiging voor {product} nog niet geaccepteerd. Bekijk wie er ontbreken en stuur ze een herinnering.}}',
  'people.menu.renotify.menu.dismiss': 'Negeren',
  'people.menu.renotify.menu.remind': 'Teamleden herinneren',
  'people.menu.renotify.menu.title': 'Is iedereen er?',
  'people.menu.renotify.modal.copied': 'Link gekopieerd',
  'people.menu.renotify.modal.copy': 'Uitnodigingslink kopiëren',
  'people.menu.renotify.modal.description':
    'We kunnen een herinnering sturen naar de ontbrekende leden, of je kunt de uitnodigingslink zelf delen.',
  'people.menu.renotify.modal.dismiss': 'Annuleren',
  'people.menu.renotify.modal.resend': 'Herinnering sturen',
  'people.menu.renotify.modal.title': 'Ontbrekende leden herinneren',
  'ptc.pm.collaborators.title': 'Je teamgenoten',
  'ptc.pm.error-heading': 'Er is iets misgegaan.',
  'ptc.pm.error-image-alt-text': 'Een defecte robot en een aantal mensen die bezig zijn hem te repareren.',
  'ptc.pm.error-text':
    'We houden deze fouten bij, maar aarzel niet om contact met ons op te nemen als pagina vernieuwen het probleem niet oplost.',
  'ptc.pm.num-members': '{memberCount, plural, one {{memberCount,number} lid} other {{memberCount,number} leden}}',
  'ptc.pm.people': 'Mensen',
  'ptc.pm.teams': 'Teams',
  'ptc.pm.view-your-profile': 'Je profiel bekijken',
  'ptc.pm.your-teams.title': 'Jouw teams',
};
